import {
  FARM_MODULES,
  type FarmModule,
} from "@/shared/farm-modules/farmModules.constants";
import { trackDials } from "@/shared/services/mixpanel";

import { icons } from "./NavbarService";

export type MenuItemType = {
  route: string;
  id: keyof typeof icons;
  translationId: string;
  dropdown?: boolean;
  onClick?: () => void;
  toggleId?: string;
  suffix?: string;
  moduleKey?: FarmModule;
};

export type UserType = {
  firstName?: string;
  lastName?: string;
  email: string;
};

const MENU_ITEMS: MenuItemType[] = [
  {
    route: "map",
    id: "map",
    translationId: "navbar.map",
  },
  {
    route: "parcels",
    id: "parcels",
    translationId: "navbar.parcels",
  },
  {
    route: "precision-farming",
    id: "precision",
    translationId: "navbar.precision",
    moduleKey: FARM_MODULES.PRECISION_FARMING,
  },
  {
    route: "telematics",
    id: "telematics",
    translationId: "navbar.telematics",
    moduleKey: FARM_MODULES.TELEMATICS,
  },
  {
    route: "sensors",
    id: "sensors",
    translationId: "navbar.sensors",
    dropdown: true,
  },
  {
    route: "irrigation/areas",
    id: "irrigation",
    translationId: "navbar.irrigation",
    dropdown: true,
    moduleKey: FARM_MODULES.IRRIGATION,
  },
  {
    route: "notifications",
    id: "notifications",
    translationId: "navbar.notifications",
    dropdown: true,
  },
  {
    route: "actions",
    id: "actions",
    translationId: "navbar.activities",
    dropdown: true,
    moduleKey: FARM_MODULES.ACTIVITIES,
  },
  {
    route: "stores",
    id: "stores",
    translationId: "navbar.stores",
    dropdown: true,
    moduleKey: FARM_MODULES.STORES,
  },
  {
    route: "reports",
    id: "reports",
    translationId: "navbar.reports",
    dropdown: true,
    moduleKey: FARM_MODULES.REPORTS,
  },
  {
    route: "catalogues/plantProtection",
    id: "classifiers",
    translationId: "navbar.catalogues",
    dropdown: true,
    onClick: trackDials,
    moduleKey: FARM_MODULES.CATALOGUES,
  },
];

export default MENU_ITEMS;
